import {Breadcrumb, Button} from "antd";
import {AodIcon} from "./AodIcon";
import React from "react";

//AodBreadcrumb.defaultProps = {  //deprecated
const defaultProps = {  //Note {...defaultProps}{...props}  props overites defaultsProps
    separator: ">",
    style: {margin: '16px 0'}
}

export default function AodBreadcrumb(
    {
        crumbs,
        clickLast = false,
        ...props
    })
{
    return <Breadcrumb {...defaultProps}{...props}>
        {crumbs.map((crumb, i) => (
            <Breadcrumb.Item
                key={i}
            >
                <CrumbDisplay last={crumbs.length-1 === i} clickLast={clickLast} crumb={crumb}/>
            </Breadcrumb.Item>
        ))}
    </Breadcrumb>
}

function CrumbDisplay({crumb, last=false, clickLast}){

    const display = <>
            <AodIcon type={crumb.type}/>
            <span> {crumb.name}</span>
        </>;
    const active = (!last || clickLast) && crumb.onClick;

    return <Button
            type="link"
            onClick={ active ? ()=>crumb.onClick(crumb) : undefined}
            style={{padding:0, ...(active?{}:{cursor:'auto'})}}
        >{display}</Button>;
}
